"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SnackBar = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));

var _SnackBarContent = _interopRequireDefault(require("../SnackBarContent"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var SnackBar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SnackBar, _Component);

  var _super = _createSuper(SnackBar);

  function SnackBar() {
    var _this;

    (0, _classCallCheck2.default)(this, SnackBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMessage", function () {
      var message = _this.props.message;
      return /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        direction: "column",
        justify: "flex-start",
        alignItems: "flex-start"
      }, message.title && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true
      }, message.title), message.message && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true
      }, message.message));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          action = _this$props.action,
          anchorOrigin = _this$props.anchorOrigin,
          autoHideDuration = _this$props.autoHideDuration,
          disableWindowBlurListener = _this$props.disableWindowBlurListener,
          message = _this$props.message,
          onClose = _this$props.onClose,
          onEnter = _this$props.onEnter,
          onEntered = _this$props.onEntered,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          onExiting = _this$props.onExiting,
          open = _this$props.open,
          overrideKey = _this$props.overrideKey,
          resumeHideDuration = _this$props.resumeHideDuration,
          className = _this$props.className; // eslint-disable-next-line no-console

      console.warn("Using a SnackBar directly has been deprecated in favor of the enqueueSnackbar function of notistack. If you still want to render a SnackBar outside of the SnackbarProvider, use SnackBarContent instead.");
      return /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
        id: id,
        className: "prmbl-snackBar ".concat(className),
        anchorOrigin: anchorOrigin,
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        key: overrideKey,
        onClose: onClose,
        onEnter: onEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        open: open,
        resumeHideDuration: resumeHideDuration
      }, /*#__PURE__*/_react.default.createElement(_SnackBarContent.default, {
        id: "".concat(id, "-snackbar-content"),
        action: action,
        message: _this.renderMessage(),
        variant: message.variant
      }));
    });
    return _this;
  }

  return SnackBar;
}(_react.Component);

exports.SnackBar = SnackBar;
(0, _defineProperty2.default)(SnackBar, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * If defined, will pass the action properties to the child SnackBarContent.
   */
  action: _propTypes.default.shape({
    action: _propTypes.default.func,
    display: _propTypes.default.node
  }),

  /**
   * If defined, will display the SnackBar in the defined horizontal and vertical position on the screen.
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOf(["left", "center", "right"]),
    vertical: _propTypes.default.oneOf(["top", "bottom"])
  }),

  /**
   * If defined, will automatically hide the snackbar after the specified number of milliseconds.
   */
  autoHideDuration: _propTypes.default.number,

  /**
   * If `true`, will continue the autoHideDuration timer if the window loses focus.
   */
  disableWindowBlurListener: _propTypes.default.bool,

  /**
   * The message contents of the snackbar
   */
  message: _propTypes.default.shape({
    /** The title to be displayed in the message */
    title: _propTypes.default.node,

    /** The message to display */
    message: _propTypes.default.node,

    /** The type of message to display */
    variant: _propTypes.default.oneOf(["success", "warning", "error", "info"])
  }),

  /**
   * Sets the parent material-ui's key property. See https://material-ui.com/api/snackbar/
   * This will ensure independent treatment of each Snackbar message and prevent `autoHideDuration` from being canceled.
   */
  overrideKey: _propTypes.default.any,

  /**
   * 	Callback fired when the component requests to be closed.
   * Typically onClose is used to set state in the parent component,
   * which is used to control the SnackBar open prop. The reason parameter
   * can optionally be used to control the response to onClose, for example
   * ignoring clickaway.
   *
   * Signature:
   * function(event: object, reason: string) => void
   * event: The event source of the callback
   * reason: Can be:"timeout" (autoHideDuration expired) or: "clickaway"
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the transition is entering
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when transition has entered
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the transition is entering
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired when the transition is exiting
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the transition has exited
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the transition is exiting
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the SnackBar is open
   */
  open: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction. If `autoHideDuration` isn't specified, it does nothing.
   * If `autoHideDuration` is specified, but `resumeHideDuration` isn't `resumeHideDuration` is defaulted to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: _propTypes.default.number,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(SnackBar, "defaultProps", {
  className: ""
});
var _default = SnackBar;
exports.default = _default;